import { PROJECT_DETAILS, PARTICULAR_PRODUCT_DETAILS } from './actionTypes';

const initialState = {
  projectDetails: null,
  particularProductDetail: null,

  loading: {
    projectDetailsLoading: false,
    particularProductDetailLoading: false,
  },
  error: {
    projectDetailsError: null,
    particularProductDetailError: null,
  },
};

const ProjectBrowserReducer = (state = initialState, action) => {
  const { type, payload, error } = action;
  switch (type) {
    // case 'PAGE_UNMOUNTED':
    //   return initialState;
    case PROJECT_DETAILS.PROJECT_DETAILS_FETCH:
      return {
        ...state,
        loading: { ...state.loading, projectDetailsLoading: true },
        error: { ...state.error, projectDetails: null },
      };
    case PROJECT_DETAILS.PROJECT_DETAILS_SUCCESS:
      return {
        ...state,
        projectDetails: payload,
        loading: { ...state.loading, projectDetailsLoading: false },
      };
    case PROJECT_DETAILS.PROJECT_DETAILS_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, projectDetailsLoading: false },
        error: { ...state.error, projectDetailsError: error },
      };
    case PARTICULAR_PRODUCT_DETAILS.PARTICULAR_PRODUCT_DETAILS_FETCH:
      return {
        ...state,
        loading: { ...state.loading, particularProductDetailLoading: true },
        error: { ...state.error, particularProductDetailError: null },
      };
    case PARTICULAR_PRODUCT_DETAILS.PARTICULAR_PRODUCT_DETAILS_SUCCESS:
      return {
        ...state,
        particularProductDetail: payload,
        loading: { ...state.loading, particularProductDetailLoading: false },
      };
    case PARTICULAR_PRODUCT_DETAILS.PARTICULAR_PRODUCT_DETAILS_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, particularProductDetailLoading: false },
        error: { ...state.error, particularProductDetailError: error },
      };
    default:
      return state;
  }
};

export default ProjectBrowserReducer;
